module.exports = __webpack_public_path__ + "static/media/cicon.bd22ea3b.png";